import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { IconTrash, IconPencil, IconCircleCheck, IconPlus } from "@tabler/icons-react";
import TableIndicator from "../../components/common/TableStatus";
import type { IArtist } from "./types";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import CreateButton from "../../components/common/CreateButton";
import RowActions from "../../components/table/RowActions";

interface IArtistRecord extends Pick<IArtist, '_id' | 'name' | 'isActive' | 'isVerified'> {
    actions: unknown;
}
const ArtistList = () => {

    const { records, paginationState, handleInteraction, deleteRecord } = useListPage<IArtistRecord>({
        apiRoute: API_ROUTE,
        clientRoute: CLIENT_ROUTE
    })

    const columns: Column<IArtistRecord>[] =  [
        {
            Header: 'Төлөв',
            accessor: 'isActive',
            Cell: ({ value }) => {
                return <TableIndicator active={value}/>;
            },
            width: 1
        },
        {
            Header: 'Баталгаажсан эсэх',
            accessor: 'isVerified',
            Cell: ({ value }) => {
                return (
                    <IconCircleCheck color={value ? '#00abfb' : 'gray'} />
                )
            }
        },
        {
            Header: 'Нэр',
            accessor: 'name',
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions deleteRecord={deleteRecord} id={table.row.original._id} clientRoute={CLIENT_ROUTE}/>
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default ArtistList;